import React from 'react';
import { Loader } from './Loader';

export const LoadingScreen: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="flex flex-col items-center gap-4">
          <Loader size="lg" className="text-emerald-500" />
          <h2 className="text-xl font-semibold text-gray-700">Loading</h2>
          <p className="text-sm text-gray-500">Please wait while we set things up...</p>
        </div>
      </div>
    </div>
  );
};